'use strict';

var _ = require('lodash');
var queryString = require('query-string');

var _require = require('./constants'),
    DEFAULT_ERROR = _require.DEFAULT_ERROR;

var handleResponse = function handleResponse(response) {
  if (response.status >= 400) {
    var responseBody = response.json();
    throw new Error(responseBody && responseBody.message || DEFAULT_ERROR);
  } else {
    return response.json();
  }
};

var handleError = function handleError(err) {
  return Promise.reject(new Error('Unable to fetch result (' + err.message + ')'));
};

var schemaArrayToObject = function schemaArrayToObject(schemaArray) {
  return _.keyBy(schemaArray, 'id');
};

var formCollectionNamesQueryParams = function formCollectionNamesQueryParams(schemaIds) {
  return queryString.stringify({ schemaIds: schemaIds });
};

module.exports = {
  handleResponse: handleResponse,
  handleError: handleError,
  schemaArrayToObject: schemaArrayToObject,
  formCollectionNamesQueryParams: formCollectionNamesQueryParams
};